import { Navigate } from 'react-router-dom';
import { canAccessPage } from '@shared/lib/access';
import { useAppSelector } from '@shared/store/hooks';

export function DefaultAuthorizedRoute() {
  const userType = useAppSelector((state) => state.exchange.userType);

  if (canAccessPage(userType, 'home')) {
    return <Navigate to="/home" replace />;
  }

  if (canAccessPage(userType, 'reports')) {
    return <Navigate to="/reports" replace />;
  }

  if (canAccessPage(userType, 'partnerManagement')) {
    return <Navigate to="/supply-partners" replace />;
  }

  if (canAccessPage(userType, 'userManagement')) {
    return <Navigate to="/user-management" replace />;
  }

  return <Navigate to="/no-access" replace />;
}
